export default {
      id: "btn_letter-usage",
      viewBox: "0 0 22 16",
      url: __webpack_public_path__ + "sprite.svg#btn_letter",
      toString: function () {
        return this.url;
      }
    }